module.exports = __webpack_public_path__ + "img/list37.ce2060bc.jpeg";